module.exports = __webpack_public_path__ + "img/logo.23f060eb.png";